<template>
  <div v-show="show">
    <div style="display: flex">
      <el-link :underline="false" style="align-items: center;margin: 20px 20px 30px auto;" @click="showClose"> X
      </el-link>
    </div>
    <el-form>
      <el-form-item>
        <div style="display: flex; align-items: center;">
          <h2 style="margin: 0; margin-right: 10px;">{{ $t('text.cardGroup') }}</h2>
          <el-select
              v-model="groupName"
              autocomplete="off"
              style="width: 205px; margin-right: 10px;"
              :placeholder="$t('text.allCard')"
              filterable
              clearable
          >
            <el-option :label="$t('text.allCard')" value=""></el-option>
            <el-option
                v-for="item in cardGroupOptionList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>

          <el-button
              type="primary"
              @click="addCardGroup"
              size="small" style=" width: 90px;height: 36px;"
          >
            {{ $t('text.addCardGroup') }}
          </el-button>

          <el-button
              type="primary"
              @click="moveOutCardGroupCheck"
              :disabled="this.multipleSelection.length === 0"
              size="small" style=" width: 90px;height: 36px;"
          >
            {{ $t('text.moveCardGroup') }}
          </el-button>

          <el-button
              type="primary"
              @click="handleShowCardSort"
              size="small" style=" width: 90px;height: 36px;"
          >
            {{ $t('text.sortCardGroup') }}
          </el-button>
        </div>
      </el-form-item>

      <div v-for="(group, index) in form2" :key="index" class="group-container">
        <el-form-item>
          <el-card class="group-card">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <h3 style="margin: 0;">{{ group.groupName }} ({{ group.cardList.length }}) </h3>
              <div>
                <el-link :underline="false" type="primary" style="margin-left: 5px;margin-right: 5px"
                         @click="editCardGroup(group)">
                  {{ $t('text.modify') }}
                </el-link>
                <el-link :underline="false" type="primary" style="margin-left: 5px;margin-right: 5px"
                         @click="deleterCardGroupCheck(group)">
                  {{ $t('text.delete') }}
                </el-link>
              </div>
            </div>
            <h4 style="margin-top: -20px;"> Group ID : {{ group.groupId }}</h4>
            <p class="group-remark">{{ group.remark }}</p>
          </el-card>

          <div class="table-container">
            <el-table
                :data="group.cardList"
                :empty-text="$t('text.noData')"
                @selection-change="handleSelectionChange"
                @row-dblclick="changeRowTable"
            >
              <el-table-column type="selection" width="42" align="left" header-align="center"/>

              <el-table-column prop="receiverCardAccount" :label="$t('text.cardName')" width="170">
                <template slot-scope="scope">
                  {{ scope.row.receiverCardAccount + '-' + getCardTypeName(scope.row.cardType) }}
                </template>
              </el-table-column>

              <el-table-column prop="priority"
                               sortable
                               :sort-method="(a, b) => Number(a.priority) - Number(b.priority)"
                               :label="$t('text.weight')"
                               width="90"
                               align="left"/>

              <el-table-column prop="usageRate"
                               :label="$t('text.useProbability')"
                               width="100"
                               align="left"/>
              <el-table-column
                  prop="dailyTransactionAmount"
                  :formatter="$formatter.YuanToThousandth"
                  :label="$t('text.dailyTradingAmount')"
                  sortable
                  :sort-method="(a, b) => Number(a.dailyTransactionAmount) - Number(b.dailyTransactionAmount)"
                  width="130"
                  align="left"
              />

              <el-table-column
                  prop="monthlyTransactionAmount"
                  :formatter="$formatter.YuanToThousandth"
                  :label="$t('text.monthlyTradingAmount')"
                  sortable
                  :sort-method="(a, b) => Number(a.monthlyTransactionAmount) - Number(b.monthlyTransactionAmount)"
                  width="130"
                  align="left"
              />
            </el-table>
          </div>

          <div v-if="!group.cards || group.cards.length > 5" class="view-toggle">
            <el-button
                type="text"
                class="toggle-button"
                @click="toggleView(index)"
            >
              {{ group.isExpanded ? $t('text.collapse') : $t('text.viewAll') }}
              <i :class="group.isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
            </el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div>

      <CardGroupEdit
          v-if="isShowEditCardGroup"
          :show.sync="isShowEditCardGroup"
          :action="action"
          :multipleSelection="multipleSelection"
          @refresh-upstream-list="refresh()">
      </CardGroupEdit>

      <CardGroupListDrawer
          v-if="isShowCardGroupListDrawer"
          :show.sync="isShowCardGroupListDrawer"
          :rowTable="rowTable">
      </CardGroupListDrawer>

      <CardSortDialog
          v-if="isShowCardSortDialog"
          :show.sync="isShowCardSortDialog"
          :initialCards="cardSort"
          @refresh-card-group-list="refreshCardGroupList()"
      />
    </div>
  </div>
</template>

<script>
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";

import CardGroupEdit from './CardGroupEdit.vue'
import CardDialogDetails from './CardDialogDetails.vue'
import CardSortDialog from './CardSortDialog.vue'

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    cardGroupList: Array,
    refreshList: Function,
  },
  components: {
    CardGroupEdit: CardGroupEdit,
    CardGroupListDrawer: CardDialogDetails,
    CardSortDialog: CardSortDialog
  },
  data() {
    return {
      tables: [],
      cardTypeList: [],
      multipleSelection: [],
      strMultipleSelection: [],
      cardStatusList: [],
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      dialogShow: this.show,
      groups: "",
      action: "",
      isButton: true,
      isDisabled: false,
      isShowEditCardGroup: false,
      isShowCardGroupListDrawer: false,
      isShowCardSortDialog: false,
      cardLists: [],
      cardGroupOptionList: [],
      rowTable: '',
      cardSort: [],
      groupName: "",
      form2: {
        isExpanded: "",
        remark: "",
        cards: [],
        cardList: [],
      },
      formDate: []
    };
  },
  watch: {
    cardGroupList: {
      immediate: true,
      handler(newVal) {
        this.cardGroupOptionList = newVal.map(group => group.groupName).sort((a, b) => a.priority - b.priority)
        this.form2 = newVal.map(group => ({
          ...group,
          isExpanded: false,
          cards: group.cards || [],
          cardList: (group.cards || []).slice(0, 5)
        }));
        this.formDate = this.form2;
      },
    },
    groupName: {
      immediate: true,
      handler(newVal) {
        if (newVal === '') {
          this.form2 = this.formDate;
        } else {
          this.form2 = this.formDate.filter(group => group.groupName === newVal);
        }
      },
    },
  },
  created() {
    this.form2 = this.cardGroupList.map(group => ({
      ...group,
      isExpanded: false,
      cards: group.cards || [],
      cardList: (group.cards || []).slice(0, 5)
    }));
    this.$axios.get("/card/selectCardTypeOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardTypeList = res.data;
      }
    });
    this.$axios.get("/card/selectCardStatusOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardStatusList = res.data;
      }
    });
  },

  methods: {
    toggleView(index) {
      const group = this.form2[index];
      group.isExpanded = !group.isExpanded;

      if (!group.originalCards) {
        group.originalCards = [...group.cards];
      }
      group.cardList = group.isExpanded
          ? group.originalCards // 展开，显示所有卡片
          : group.originalCards.slice(0, 5); // 收起，显示前 5 个卡片
    },
    closeDialog() {
      this.form2 = {};
      // this.$refs["form2"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    showClose() {
      this.$emit("update:show", false);
    },
    addCardGroup() {
      this.action = "add";
      this.isShowEditCardGroup = true;
    },
    editCardGroup(group) {
      this.action = "edit";
      this.multipleSelection = group;
      this.isShowEditCardGroup = true;
    },
    getCardTypeName(value) {
      if (value === undefined || value === null) {
        return 'undefined';
      }
      const cardType = this.cardTypeList.filter(x => x.value === value)[0]
      if (cardType === undefined || cardType === null) {
        return 'undefined';
      }
      return cardType.name;
    },
    refresh() {
      this.fetchCardGroupList();
      this.$bus.$emit("refresh"); //通知刷新
      this.$emit("refresh-card-group"); //通知刷新
      this.$emit("refresh-card-card-list"); //通知刷新
    },
    refreshCardGroupList() {
      this.$bus.$emit("refresh"); //通知刷新
      this.$emit("refresh-list"); //通知刷新
      this.fetchCardGroupList();
    },
    deleterCardGroupCheck(group) {
      this.multipleSelection = group;
      const usedCardCount = this.multipleSelection.cardList.filter((x) => x.status === "03").length;
      const usedCardList = this.formatCardList(this.multipleSelection.cardList.filter((x) => x.status === "03"));
      this.$confirm(
          this.$t('text.confirmDeleteGroup', {
            groupName: this.multipleSelection.groupName,
            usedCardCount,
            usedCardList
          }),
          this.$t('text.deleteCardGroup'),
          {
            dangerouslyUseHTMLString: true, // 关键：启用 HTML 渲染
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
          }
      ).then(() => {
        try {
          this.deleterCardGroup();
        } catch (error) {
          console.error('发生错误:', error); // 捕获潜在错误
        }
      })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('text.cancel'),
            });
          });
    },
    deleterCardGroup() {
      this.$axios
          .delete('/card-group/deleteCardGroup', {
            params: {
              cardGroupId: Number(this.multipleSelection.groupId),
            }
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('text.operationSuccessful'));
              this.refresh();
            }
          }).catch((error) => {
        console.error('请求失败:', error);
        this.$message.error(this.$t('text.operationFailed'));
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatCardList(cards) {
      const uniqueCards = [
        ...new Set(
            cards.map((card) => `"${card.receiverCardAccount}-${this.getCardTypeName(card.cardType)} "`)
        ),
      ];

      if (uniqueCards.length <= 3) {
        return uniqueCards.join('<br>');
      }

      return [
        uniqueCards[0],          // 第一笔
        uniqueCards[1],          // 第二笔
        '...',                   // 中间简略部分
        uniqueCards[uniqueCards.length - 1], // 最后一笔
      ].join('<br>');
    },
    moveOutCardGroupCheck() {
      this.$confirm(this.$t('text.confirmActionMessage'),
          {
            dangerouslyUseHTMLString: true, // 关键：启用 HTML 渲染
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'warning',
          }
      ).then(() => {
        try {
          this.moveOutCardGroupMethod();
        } catch (error) {
          console.error('发生错误:', error); // 捕获潜在错误
        }
      })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('text.cancel'),
            });
          });
    },
    moveOutCardGroupMethod() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('text.selectRow'));
        return;
      }

      const cardList = this.multipleSelection.map(selection => Number(selection.cardId));
      const requestBody = {};

      this.$axios
          .put('/card/removeFromGroup', requestBody, {
            params: {
              cardIds: cardList.join(','),
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('text.operationSuccessful'));
              this.refresh();
            }
          }).catch((error) => {
        console.error('请求失败:', error);
        this.$message.error(this.$t('text.operationFailed'));
      });
    },
    fetchCardGroupList() {
      this.loading = true;
      this.$axios.get("/card-group/selectList", {params: {}}).then((res) => {
        if (res.code === 200) {
          this.$emit('refresh-list', res.data.list);
          this.loading = false;
        }
      })
      this.loading = false;
    },
    handleShowCardSort() {
      this.cardSort = this.form2;
      this.isShowCardSortDialog = true;
    },
    changeRowTable(row) {
      this.rowTable = row;
      this.isShowCardGroupListDrawer = true;
    }
  },
};
</script>

<style scoped>
.responsive-container {
  padding: 20px;
}

.view-toggle-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #f0f7ff;
  border-top: 1px solid #e4e7ed;
}

.view-toggle-button {
  color: #1890ff;
  font-size: 14px;
  padding: 6px 12px;
  transition: color 0.3s;
}

.view-toggle-button:hover {
  text-decoration: underline;
  color: #40a9ff;
}
</style>
